import PrimaryButton from "components/primaryButton/PrimaryButton";
import TextInput from "components/textInput/TextInput";
import { Formik } from "formik";
import { Form, Spinner } from "react-bootstrap";
import { styled } from "styled-components";
import * as Yup from "yup";
import Error from "components/error/Error";

const InputTextArea = styled(TextInput)`
  height: 200px;
`;

interface EncodeInputProps {
  onSubmit: (input: string) => void;
  header: string;
  error: string | undefined;
  busy: boolean;
  buttonText: string;
  showInput?: boolean | undefined;
}

const EncodeInput = (props: EncodeInputProps) => {
  const { onSubmit, header, error, busy, buttonText, showInput = true } = props;

  const schema = Yup.object({
    input: showInput
      ? Yup.string().required("Input is a required field")
      : Yup.string(),
  });

  const handleSubmit = (values: any) => {
    onSubmit(values.input);
  };

  return (
    <>
      <span className="mb-4 d-block">{header}</span>
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        initialValues={{
          input: "",
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit} autoComplete="off">
            {showInput && (
              <Form.Group className="mb-4" controlId="input">
                <InputTextArea
                  id="input"
                  spellCheck={false}
                  className="form-control"
                  textarea={true}
                  hasError={
                    props.touched.input && props.errors.input !== undefined
                  }
                  value={props.values.input}
                  onChange={props.handleChange}
                />
              </Form.Group>
            )}

            <Error text={error} />

            <PrimaryButton disabled={busy}>
              {!busy && <span>{buttonText}</span>}
              {busy && <Spinner size="sm" />}
            </PrimaryButton>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default EncodeInput;
